import { Component, OnInit, OnChanges, Input, EventEmitter, Output, forwardRef, SimpleChanges, ViewChild, ElementRef, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IAppConfig } from '../../config/app-config.model';
import { AppConfig } from '../../config/app-config.service';

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
})
export class FileUploadComponent  implements OnInit {

    appSettings: IAppConfig;
    file: File = null;
    typeError: boolean = false;
    nameError: boolean = false;
    fileSizeError: boolean = false;
    filePlaceholder: string = '';

    // @ViewChild('fileRef')
    fileRef: ElementRef;

    @Output() fileChanged = new EventEmitter<File>();

    @Input('allowedTypes') allowedTypes: string = '';

    @Input('allowedTypesText') allowedTypesText: string;

    constructor(translateService: TranslateService, ngZone: NgZone) {
        this.appSettings = AppConfig.settings;
    }

    ngOnInit() {
        if (this.allowedTypes === '') {
            this.allowedTypes = this.appSettings.allowedFileTypes;
        }
    }

    handleFile(files) {

        if (files == null || !files.item(0)) return;

        let fileName = files.item(0).name;

        let fileSize = files.item(0).size;

        if (fileSize > 5000000) {
            this.fileSizeError = true;
            this.fileRef.nativeElement.value = '';
            return;
        } else {
            this.fileSizeError = false;
        }

        if (fileName.length > 50) {
            this.nameError = true;
            this.fileRef.nativeElement.value = '';
            return;
        } else {
            this.nameError = false;
        }

        let extension: string = fileName.split('.')[fileName.split('.').length - 1];

        extension = extension.toLowerCase();

        if (!this.allowedTypes.includes(extension)) {
            this.fileRef.nativeElement.value = '';
            this.typeError = true;
            setTimeout(() => {
                this.typeError = false;
            }, 3000);
            return;
        }
        this.file = files.item(0);
        this.fileRef.nativeElement.placeholder = fileName;
        this.fileChanged.emit(this.file);
        this.filePlaceholder = fileName;

    }

    clear() {
        this.file = null;
        this.fileRef.nativeElement.placeholder = '';
        this.fileChanged.emit(this.file);
    }
}
